import { fromJS } from 'immutable';
import { valIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchPageContent } from '@client/connectivity/api.cms';
import {
  loadFundraisers,
  loadFundraiserTypes,
} from '@client/redux/fundraiser/fundraiserActions';

export const DUCK_MEMORIAL_FUNDRAISERS_PAGE_KEY = 'duckMemorialPageReducer';

const SET_MEMORIAL_FUNDRAISERS_PAGE_ERROR =
  'SET_MEMORIAL_FUNDRAISERS_PAGE_ERROR';
const LOAD_MEMORIAL_FUNDRAISERS_PAGE_CMS = 'LOAD_MEMORIAL_FUNDRAISERS_PAGE_CMS';

/* REDUCER */
let defaultState = fromJS({
  pageData: {},
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_MEMORIAL_FUNDRAISERS_PAGE_CMS: {
      return state.merge({ pageData: action.payload, errorMessage: '' });
    }
    case SET_MEMORIAL_FUNDRAISERS_PAGE_ERROR: {
      return state.merge({
        errorMessage: action.payload,
      });
    }
    default:
      return state;
  }
}

/* ACTIONS */
export function loadMemorialFundraisersPageCms() {
  return function (dispatch) {
    return fetchPageContent('memorialFundPage').then((response) => {
      return dispatch({
        type: LOAD_MEMORIAL_FUNDRAISERS_PAGE_CMS,
        payload: response,
      });
    });
  };
}

export function loadMemorialFundraisersPageData() {
  return function (dispatch) {
    const eventPageDataPromises = [
      dispatch(loadMemorialFundraisersPageCms()),
      dispatch(loadFundraisers(`?FundraiserType=2`)),
      dispatch(loadFundraiserTypes()),
    ];

    return Promise.all(eventPageDataPromises);
  };
}

/* SELECTORS */
export const selectMemorialPageData = (state) => {
  return valIn(state[DUCK_MEMORIAL_FUNDRAISERS_PAGE_KEY], 'pageData');
};
